import React from 'react'

import { SinglePanePage, screenSize } from 'styles/shared'
import styled from 'styled-components'

import Modal from 'components/Modal'

import FeaturesBox from './FeaturesBox'
import { color } from 'styles/colors'

type Props = {
  isDeactivated?: boolean,
  closeCallback: (reload: boolean) => void
}

const PremiumFeaturesModal = ({ isDeactivated = false, closeCallback } : Props) => {
  return (
    <Modal variant="sm" isDisplayed closeCallback={() => closeCallback(false)} title="">
      <S.Top />
      <SinglePanePage>
        <S.Features>
          <S.CurrentPlan>
            {isDeactivated &&
              <S.PlanTitle>Your Current Plan</S.PlanTitle>
            }
            <FeaturesBox isStandardList enableCompareMode />
          </S.CurrentPlan>
          <S.CurrentPlan>
            {!isDeactivated &&
              <S.PlanTitle>Your Current Plan</S.PlanTitle>
            }
            <S.FeaturesBox isStandardList={false} enableCompareMode />
          </S.CurrentPlan>
        </S.Features>
      </SinglePanePage>
    </Modal>
  )
}

export default PremiumFeaturesModal

const S = {
  Features: styled.div`
    display: grid;
    grid-template-columns: 1fr 1fr;
    column-gap: 10px;
    margin-top: 15px;
    
    @media ${screenSize.small} {
      display: flex;
      gap: 40px;
      flex-direction: column;
      align-items: center;
      margin-bottom: 40px;
    }
  `,
  PlanTitle: styled.div`
    width: 100%;
    text-align: center;
    font-size: 16px;
    position: absolute;
    top: -30px;
    color: ${color('secondaryText')};
    font-style: italic;
  `,
  Top: styled.div`
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 10px;
  `,
  CurrentPlan: styled.div`
    position: relative;
  `,
  FeaturesBox: styled(FeaturesBox)`
    height: 100%;
  `
}
